// "You may also like" (sections/related-products.liquid): once <lazy-section> has swapped in the recommended cards,
// a section with none (or a failed request) hides, so no empty heading is left on the page.
const check = (lazy) => {
  const section = lazy?.closest('[data-related]');
  if (!section || !lazy.dataset.state || lazy.dataset.state === 'loading') return;
  section.hidden = lazy.dataset.state === 'error' || !lazy.querySelector('[data-card]');
};

['lazy-section:loaded', 'lazy-section:error'].forEach((type) =>
  document.addEventListener(type, (event) => check(event.target))
);

// Loaded before this module ran.
document.querySelectorAll('[data-related] lazy-section').forEach(check);
